import React, { useState } from 'react';
import Loading from '../../../Components/Loading';
import { useEffectAsync } from '../../../helpers';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import { useRootWorkplaceByChildQuery } from '../../../graphql/graphql';

export interface ManagerContextProviderProps {
	children?: React.ReactChild | React.ReactChild[];
	isSuperAdmin: boolean;
	workplaceId: string;
}

export interface ManagerContextProps {
	isSuperAdmin: boolean;
	healthPlanCode?: HealthPlanCode;
	setHealthPlanCode: (healthPlanCode?: HealthPlanCode) => void;
	workplaceId: string;
	rootWorkplaceId?: string;
}

export const ManagerContext = React.createContext<ManagerContextProps>({
	isSuperAdmin: false,
	healthPlanCode: undefined,
	setHealthPlanCode: () => {},
	workplaceId: '',
	rootWorkplaceId: undefined,
});

export const useManagerContext: () => ManagerContextProps = () => {
	return React.useContext<ManagerContextProps>(ManagerContext);
};

export function ManagerContextProvider({
	children,
	isSuperAdmin,
	workplaceId,
}: ManagerContextProviderProps) {
	const [isLoading, setIsLoading] = useState(false);
	const [healthPlanCode, setHealthPlanCode] = useState<
		HealthPlanCode | undefined
	>(undefined);
	const { data, isLoading: rootWorkplaceIsLoading } =
		useRootWorkplaceByChildQuery({ workplaceId });
	const rootWorkplaceId = data?.workplace?.rootWorkplace?.id;

	useEffectAsync(async () => {}, []);

	return (
		<ManagerContext.Provider
			value={{
				isSuperAdmin,
				healthPlanCode,
				setHealthPlanCode,
				workplaceId,
				rootWorkplaceId,
			}}>
			{isLoading && <Loading />}
			{!isLoading && children}
		</ManagerContext.Provider>
	);
}
